import { Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import { useEmployee } from '../Contexts/EmployeeContext';

const AdminRoute = ({ children }: { children: JSX.Element }) => {
  const isAuthenticated = useIsAuthenticated();
  const { employee } = useEmployee();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (employee.Role === 2 || employee.Role === 3) {
    return children;
  }

  return <Navigate to="/unauthorized" replace />;
};

export default AdminRoute;
